export const APP_NAME = "人才政策";
export const APP_AUTH_KEY = "Authorization-policy";
export const APP_USER_SOURCE = "PC_QY";
export const YOUNG_FORM_KEY = "young_house_subsidy"; //  郑州市青年人才购房补贴
export const YOUNG_FORM_KEY_17 = "young_house_subsidy_zz2017"; //  郑州市青年人才购房补贴（2017年后毕业生）
export const YOUNG_FORM_KEY_22 = "young_house_subsidy_zz2022"; //  郑州市青年人才购房补贴（2022年后毕业生）
// export const SKILL_FORM_KEY = "1570579213277770001"; //
